import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';
import { Model } from './model';

export class TimeOccurrenceParametersModel extends Model implements IModel<TimeOccurrenceParametersModel> {
  enableConditionalHoursBankFilter: boolean = false;
  enableMandatoryDocsFilter: boolean = false;
  anyoneCanViewExceptions: boolean = true;
  enableOvertimeJustification: boolean = false;
  enableOvertimeApprovalReason: boolean = false;
  anyoneCanPreHandling: boolean = false;
  anyoneCanCreateOwnExcusedAbsence: boolean = false;
  daysToSendDocumentBeforeOccurrence: number = 0;
  canCreateRetroativeExceptions: boolean = true;
  enablePreAbono: boolean = false;
  hasHourControlExcusedAbsence: boolean = false;
  disablePointTimeException: boolean = false;
  disableTransferTimeShift: boolean = false;
  notificationMsgGestor: string = null;
  notificationMsgAdmin: string = null;
  notificationScheduleCron: string = null;
  occurrenceSyncScheduleCron: string = null;
  leaderNotificationScheduleCron: string = null;
  adminNotificationScheduleCron: string = null;

  static create(input: any): TimeOccurrenceParametersModel {
    return ObjectMapper.deserialize<TimeOccurrenceParametersModel>(TimeOccurrenceParametersModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  public hasEnabled(flagName: string): boolean {
    return flagName in this && (this as any)[flagName] === true;
  }
}
